module.exports = {
  server: {
    CORS_SETUP_IS_ENABLE: false,
    SERVER_PORT: 3000,
  },
  client: {
    ENVIRONMENT: `staging`,
    API_BASEURL: 'https://api-staging.parenteque.com/',
    AWS_REGION: 'ap-southeast-2',
    AWS_BUCKET_INPUT: 'parenteque-input-staging',
    AWS_ACCESS_KEY_ID: 'AKIA5QVBVK6IZ3M4JDOP',
    AWS_SECRET_ACCESS_KEY: '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',
    AWS_MEDIA_CONVERT_ENDPOINT:
      'https://z5xjggzna.mediaconvert.ap-southeast-2.amazonaws.com',
  },
}
